import {
  IDocumentImageSource,
} from "../../../../../../../domain/document";
import {
  IItem,
  ImageItem,
  IImageDrawable,
} from "../../../../../../../domain/document/items";
import { IValueAccessible } from "../IValueAccessible";
import { AbstractValueAccessor, AbstractImageDrawableAccessor } from "./AbstractValueAccessor";

export class ImageDrawableImageSourceAccessor extends AbstractValueAccessor<IDocumentImageSource> {
  constructor(source: IItem) {
    super(ImageDrawableImageSourceAccessor._createAccessor(source));
  }
  
  private static _createAccessor(source: IItem): IValueAccessible<IDocumentImageSource> {
    if (source instanceof ImageItem) {
      return new ImageItemImageSourceAccessor(source);
    }
    throw new Error("対象外オブジェクト");
  }
}

abstract class AbstractImageSourceAccessor<T extends IItem & IImageDrawable> extends AbstractImageDrawableAccessor<T, IDocumentImageSource> {
  constructor(source: T) {
    super(source);
  }
}

class ImageItemImageSourceAccessor extends AbstractImageSourceAccessor<ImageItem> {
  constructor(source: ImageItem) {
    super(source);
  }

  protected _validate(source: ImageItem): void {}

  protected _get(source: ImageItem): IDocumentImageSource {
    return source.imageSource;
  }

  protected _set(source: ImageItem, value: IDocumentImageSource): void {
    source.clearImageInformation();
    source.replaceImageSource(value);
  }
}
